import { render, staticRenderFns } from "./ViewManager.vue?vue&type=template&id=844ecb9e&"
import script from "./ViewManager.vue?vue&type=script&lang=js&"
export * from "./ViewManager.vue?vue&type=script&lang=js&"
import style0 from "./ViewManager.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports